import { render, staticRenderFns } from "./Updatereal.vue?vue&type=template&id=e2fb06ae"
import script from "./Updatereal.vue?vue&type=script&lang=js"
export * from "./Updatereal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports